import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from "@mui/material";
import { styled } from '@mui/system';

const TooltipContent = styled('div')({
    maxHeight: '300px',   // Set the maximum height for the tooltip
    minHeight: '10px',    // Set the minimum height for the tooltip
    overflowY: 'auto',    // Enable vertical scrolling when content exceeds maxHeight
    paddingTop: '10px',     // Optional: Adjust padding as needed
    paddingRight: '10px',
    paddingBottom: '10px',
    marginTop: '-10px',
    marginBottom: '-10px',
    marginLeft: '-10px',
    paddingLeft: '10px',
    maxWidth: 'min(300px, calc(100vw - 24px))',
    boxSizing: 'border-box',
    whiteSpace: 'pre-line', // Preserve line breaks if the title is a string
});

/** Keeps tooltip within the viewport (Popper uses mergeByName; later duplicate modifiers win). */
const mergeViewportSafePopperProps = (incoming = {}) => {
    const incomingOptions = incoming.popperOptions || {};
    const incomingMods = incomingOptions.modifiers || [];
    return {
        ...incoming,
        popperOptions: {
            ...incomingOptions,
            strategy: incomingOptions.strategy ?? 'fixed',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                        padding: 16,
                        altBoundary: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: [
                            'bottom',
                            'left',
                            'right',
                            'top-start',
                            'top-end',
                            'bottom-start',
                            'bottom-end',
                        ],
                    },
                },
                ...incomingMods,
            ],
        },
    };
};

const MuiTooltip = ({ children, PopperProps, ...props }) => {
    const { title } = props;
    return (
        <Tooltip
            arrow={true}
            // open={true}
            placement={"top"}
            {...props}
            PopperProps={mergeViewportSafePopperProps(PopperProps)}
            title={
                title ? (
                    <TooltipContent>
                        <div className="">{title}</div>
                    </TooltipContent>
                ) : null
            }
        >
            {children}
        </Tooltip>
    );
};

MuiTooltip.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default MuiTooltip;
